import { render, staticRenderFns } from "./LogoutIcon.vue?vue&type=template&id=120c9d99&scoped=true&"
import script from "./LogoutIcon.vue?vue&type=script&lang=js&"
export * from "./LogoutIcon.vue?vue&type=script&lang=js&"
import style0 from "./LogoutIcon.vue?vue&type=style&index=0&id=120c9d99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120c9d99",
  null
  
)

export default component.exports